/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserRoleAssignmentResponse interface.
 */
export function instanceOfUserRoleAssignmentResponse(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('isExpired' in value) || value['isExpired'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    return true;
}
export function UserRoleAssignmentResponseFromJSON(json) {
    return UserRoleAssignmentResponseFromJSONTyped(json, false);
}
export function UserRoleAssignmentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'grantedAt': json['granted_at'] == null ? undefined : (new Date(json['granted_at'])),
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'isExpired': json['is_expired'],
        'isActive': json['is_active'],
    };
}
export function UserRoleAssignmentResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'granted_at': value['grantedAt'] == null ? undefined : ((value['grantedAt']).toISOString()),
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'is_expired': value['isExpired'],
        'is_active': value['isActive'],
    };
}
